import { createStyles, makeStyles } from "@material-ui/core";


export default makeStyles((theme) => createStyles({
    container: {
        display: "flex",
        flexDirection: "row",
        width: 200,
    },
    icon: {
        height: 48,
        width: 48,
        border: `1px solid ${theme.palette.grey["300"]}`,
        borderRadius: "50%",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: "0 12px",
    },
    title: {
        textTransform: "capitalize",
        fontWeight: "bold",
    },
    subTitle: {
        textTransform: "capitalize",
        fontWeight: "normal",
    },
}));
